import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { Page, PageHeader } from "components/ui/Page";
import WithMyAcademics from "../data/WithMyAcademics";
import WithSemesters from "../data/WithSemesters";
import { SemesterCoursesCard } from "../cards/SemesterCoursesCard";
import { FinalGradesCard } from "../cards/FinalGradesCard";
import { SemesterSwitcher } from "components/SemesterSwitcher";

import { LargeSpacer } from "components/ui/VerticalSpacers";
import { PageColumn, EvenThirdsLayout } from "components/ui/PageColumns";
import SemestersContext from "../contexts/SemestersContext";

import { InstructorFinalExamScheduleCard } from "../cards/InstructorFinalExamScheduleCard";
import { StudentFinalExamScheduleCard } from "../cards/StudentFinalExamScheduleCard";

// https://wikihub.berkeley.edu/display/SIS/CalCentral+My+Academics+Semester+Page
export function SemesterPage() {
  return (
    <Page>
      <WithMyAcademics>
        <WithSemesters>
          <SemesterPageUI />
        </WithSemesters>
      </WithMyAcademics>
    </Page>
  );
}
SemesterPage.displayName = "SemesterPage";

const SemesterPageUI = () => {
  const { currentSemester, currentTeachingSemester } =
    useContext(SemestersContext);

  return (
    <>
      <SemesterPageHeader />
      <LargeSpacer />

      <EvenThirdsLayout style={{ gridTemplateColumns: `2fr 1fr` }}>
        <PageColumn>
          <SemesterCoursesCard title="Classes" />

          <StudentFinalExamScheduleCard currentSemester={currentSemester} />
          {currentTeachingSemester && (
            <InstructorFinalExamScheduleCard
              currentSemester={currentTeachingSemester}
            />
          )}
        </PageColumn>
        <PageColumn>
          <FinalGradesCard />
        </PageColumn>
      </EvenThirdsLayout>
    </>
  );
};

const SemesterPageHeader = () => {
  const { currentSemester } = useContext(SemestersContext);

  return (
    <PageHeader
      style={{
        display: `flex`,
        justifyContent: `space-between`,
        alignItems: `baseline`,
      }}
    >
      <div>
        <Link to="/academics">My Academics</Link> » {currentSemester?.name}
      </div>
      <SemesterSwitcher />
    </PageHeader>
  );
};
